import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const SESSION_KEY = "djf_session_id";

function getSessionId() {
  let id = localStorage.getItem(SESSION_KEY);
  if (!id) {
    id = `s_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
    localStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

export default function VisitTracker() {
  const location = useLocation();
  const lastTracked = useRef(null);

  useEffect(() => {
    // Skip admin routes (don't pollute analytics with admin own visits)
    if (location.pathname.startsWith("/admin")) return;
    // Dedupe identical consecutive calls within same render cycle
    const key = `${location.pathname}${location.search}`;
    if (lastTracked.current === key) return;
    lastTracked.current = key;

    const sid = getSessionId();
    axios
      .post(`${API}/visits`, {
        path: key,
        session_id: sid,
        referrer: document.referrer || null,
      })
      .catch(() => {});
  }, [location.pathname, location.search]);

  return null;
}
